import classNames from 'classnames';
import React from 'react';

import { Text } from 'tradera/components/atoms/text/text';

export type BaseInputWrapperProps = {
    label?: React.ReactNode;
    hint?: React.ReactNode;
    // A string or ReactNode can be used as the error message and error styling, a boolean will only give error styling
    error?: boolean | React.ReactNode;
    help?: React.ReactNode;
    name?: string;
    children: React.ReactNode;
    /**
     * This will collapse the hint/error area when there's no info
     */
    collapsed?: boolean;
    className?: string;
    style?: React.CSSProperties;
};

const isVisibleNode = (error: BaseInputWrapperProps['error']) => {
    return (
        (typeof error === 'string' && !!error) ||
        (typeof error === 'object' && error !== null)
    );
};

export const BaseInputWrapper = ({
    label,
    error,
    hint,
    help,
    name,
    collapsed,
    className,
    style,
    children
}: BaseInputWrapperProps) => {
    const textBelow = isVisibleNode(error) ? (
        error
    ) : isVisibleNode(hint) ? (
        hint
    ) : // &nbsp; is to make sure that this element always has a height,
    // otherwise the form will jump when the error message is shown, if
    // no hint is provided
    collapsed ? (
        ''
    ) : (
        <>&nbsp;</>
    );

    const hasLabelOrHelp = !!label || !!help;

    return (
        <div
            className={classNames('d-flex flex-column flex-grow-1', className)}
            style={style}>
            {hasLabelOrHelp ? (
                <div className="d-flex align-items-center justify-content-between mb-1">
                    <Text as="label" font="hansen" htmlFor={name}>
                        {label}
                    </Text>
                    <Text
                        as="span"
                        color="gray-600"
                        fontWeight="medium"
                        size="oslo">
                        {help}
                    </Text>
                </div>
            ) : null}
            {children}
            {textBelow ? (
                <Text
                    // TODO: maybe only alert if there is an error?
                    role={error ? 'alert' : undefined}
                    color={error ? 'danger' : 'gray-600'}
                    size="oslo"
                    fontWeight="medium"
                    className="mt-1">
                    {textBelow}
                </Text>
            ) : null}
        </div>
    );
};
